<template>
  <div class="control_bar top">
    <div class="search">
      <input type="text" class="search_field" placeholder="電話番号、名前、ふりがな、職種、役職、ユーザ IDから検索" v-model="inputValue" />
    </div>
    <controller :dispItems="dispItems" @input-event="setSearchList" @reload="reload" @clear-isOpen="clearIsOpen" @clearFileDownloadUserIDList="clearFileDownloadUserIDList"></controller>
  </div>
</template>

<script>
import controller from '../controllerLoginUser.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      isOpen: []
    }
  },
  computed: {},
  components: {
    controller
  },
  methods: {
    setSearchList(event) {
      this.$store.dispatch('loginUsers/clearSelectedLoginUsersList')
      this.$emit('input-event', 0, this.inputValue)
    },
    reload() {
      this.$emit('reload')
    },
    clearIsOpen(e) {
      this.isOpen = e
      this.$emit('clear-isOpen', this.isOpen)
    },
    clearFileDownloadUserIDList(e) {
      this.$emit('clearFileDownloadUserIDList')
    }
  }
}
</script>

<style scoped>
.search {
  width: 100%;
  height: 55px;
}
.search_field {
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/loginUsers/controlbar.vue